import React, { useEffect, useState } from "react";
import AllTaxiReqTabel from "../../Tables/Taxi/AllTaxiReqTabel/AllTaxiReqTabel";
import { getTravelsListApi } from "../../../Api/PanelAdminServices";
import { errorToast } from "./../../../Utils/Toast/Toast";
import { Modal } from "react-bootstrap";
import TravelDetailModal from "../../Modal/TravelDetailModal/TravelDetailModal";
import moment from "moment-jalaali";

const AllTaxiRequestContainer = () => {
  const [travelsState, setTravelsState] = useState([]);
  const [travelDetaiModalState, setTravelDetaiModalState] = useState(false);
  const [travelId, setTravelId] = useState(false);
  const getDataHandler = () => {
    getTravelsListApi((res) => {
      if (res.status === 1) {
        setTravelsState(res.travels);
      } else {
        errorToast(res.message);
      }
    });
  };
  useEffect(() => {
    getDataHandler();
  }, []);
  const openModalHandler = (record) => {
    setTravelDetaiModalState(true);
    setTravelId(record.key)
  };
  const data =
    travelsState &&
    travelsState.map((item, index) => {
      return {
        key: item.id,
        driver: item.driver_name === null ? "در انتظار" : item.driver_name,
        // driver: item.driver_name,
        driverphone:
          item.driver_phone === null ? "در انتظار" : item.driver_phone,
        passengerName: item.name,
        passengerPhone: item.phone,
        payment: item.delivery,
        taxi_Request: moment.unix(parseInt(item.request_date)).format("jYYYY/jM/jD----hh:mm:ss a"),
        status:item.status
          
      };
    }).sort((a,b)=>b.key-a.key);
  return (
    <div className="w-100 bg-white d-flex flex-column align-items-center py-3">
      <Modal
        className="RTL"
        show={travelDetaiModalState}
        onHide={() => setTravelDetaiModalState(false)}
      >
        <Modal.Header>
          <Modal.Title className="w-100 fs-6">جزئیات سفر</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TravelDetailModal travelId={travelId}/>
        </Modal.Body>
      </Modal>
      <AllTaxiReqTabel data={data} modalHandler={openModalHandler} />
    </div>
  );
};

export default AllTaxiRequestContainer;
